 <thm-page [class.aof-page]="!loginMi">
    <ng-template let-title="title" let-menu="menu" let-breadcrumb="breadcrumb" let-sidebarNarrow="sidebarNarrow">

        <thm-header>
            <ng-template>

                <ng-container *transloco="let t">
                <div class="navbar-text-area">
                    <aof-header-logo></aof-header-logo>
                </div>

                <thm-navbar-nav>
                    <thm-nav-item *ngIf="loginMi" [path]="'/'" [iconClass]="'fas fa-home'"
                    [title]="isMobileResolution ? t('header.home') : ''">
                    {{ isMobileResolution ? '' : t('header.home') }}
                    </thm-nav-item>
                    <thm-nav-item *ngIf="loginMi" [path]="'/aday/gecmis-basvurular'" [iconClass]="'fas fa-history'"
                    [title]="isMobileResolution ? t('header.gecmisBasvurular') : ''">
                    {{ isMobileResolution ? '' : t('header.gecmisBasvurular') }}
                    </thm-nav-item>
                    <aof-nav-item *ngIf="loginMi && adminMi" (click)="modalGoruntule = true" [iconClass]="'fas fa-user-cog'"
                    [title]="isMobileAdminResolution ? t('header.ogrenciSecimi') : ''">
                    {{ isMobileAdminResolution ? '' : t('header.ogrenciSecimi') }}
                    </aof-nav-item>
                    <div *ngIf="dilSecimiAcikMi" class="nav-lang-container">
                        <div class="nav-lang">
                            <button class="nav-lang__btn" [class.active]="currentLang === 'tr'" (click)="setLang('tr')">TR</button>
                            <button class="nav-lang__btn" [class.active]="currentLang === 'en'" (click)="setLang('en')">EN</button>
                        </div>
                    </div>
                    <aof-user-panel class="nav-user-panel"></aof-user-panel>
                </thm-navbar-nav>
                </ng-container>

            </ng-template>
        </thm-header>

        <thm-modal [(visible)]="modalGoruntule" [maxWidth]="500" [title]="'header.ogrenciSecimi' | transloco">
            <aof-ogrenci-secim [islemYapilacakModul]="moduller.YeniBasvuru" (close)="modalKapat()">
            </aof-ogrenci-secim>
        </thm-modal>

        <thm-jumbotron></thm-jumbotron>

        <thm-breadcrumb [data]="breadcrumb"></thm-breadcrumb>

        <div *ngIf="adminMi && (onBasvuruyaBasladiMi || basvuruyaBasladiMi || !resimBasariliMi)"
            class="hidden-mobile admin-islemleri d-flex justify-content-end">
            <strong> {{ ('master.islemYapilanAday' | transloco) + ':' + adayBilgi}}</strong>
        </div>

        <div class="display-mobile admin-islemleri d-flex justify-content-end align-items-center">

            <div class="mobile-menu-container mb-0" *ngIf="!onBasvuruyaBasladiMi && !basvuruyaBasladiMi">
                <aof-menu></aof-menu>
            </div>
            <div class="float-left pt-1">
                <strong>
                    <span [innerHTML]="'menu.hosgeldiniz2' | transloco: {adSoyad: adayBilgi}"></span>
                </strong>
            </div>

        </div>

        <thm-main>
            <thm-sidebar class="hidden-mobile" *ngIf="!onBasvuruyaBasladiMi && !basvuruyaBasladiMi">
                <aof-menu></aof-menu>
            </thm-sidebar>

            <thm-page-content [title]="title" [class.col-lg-12]="onBasvuruyaBasladiMi || basvuruyaBasladiMi">
                <div class="main-font-size">
                    <router-outlet></router-outlet>
                </div>
            </thm-page-content>

        </thm-main>
    
        <thm-footer></thm-footer>

    </ng-template>
</thm-page>